import Vue from 'vue';
import Router from 'vue-router';
import NewCustomer from '@/views/products-and-services/NewCustomer.vue';
import ProductsAndServices from '@/views/products-and-services/ProductsAndServices.vue';
import OrderReview from '@/views/products-and-services/OrderReview.vue';
import Success from '@/views/products-and-services/Success.vue';
import RescheduleFollowUp from '@/views/products-and-services/RescheduleFollowUp.vue';

Vue.use(Router);

const router = new Router({
    scrollBehavior() {
        return { x: 0, y: 0 };
      },
    routes: [
        {
            path: '/',
            component: ProductsAndServices,
            name: 'productsAndServices',
            meta: {
                isHome: true,
                breadCrumb: 'Residential Products'
            },
            children: [
                        {
                            path: 'new-customer',
                            name: 'newCustomer',
                            component: NewCustomer,
                            props: true,
                            meta: {
                                breadCrumb: 'Your Information',
                                onNewCustomer: true
                            },
                            children:[
                                {
                                    path: 'order-review',
                                    name: 'OrderReview',
                                    component: OrderReview,
                                    props: true,
                                    meta: {
                                        breadCrumb: 'Order Review'
                                    }
                                },
                            ]
                        },
                    ]
        },
        {
        path: '/success',
            component: Success,
            name: 'Success',
        },
        {
            path: '/reschedule-follow-up',
            component: RescheduleFollowUp,
            name: 'Reschedule Follow Up',
        },
        {
            path: '*',
            redirect: '/'
        }
    ]
});

Vue.use(Router);

export default router;
